import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { CurriculumStore } from 'src/app/stores/resources/curriculum.store';
import { ACHIEVEMENT_TEST } from 'src/app/dummy/testing';

@Component({
  selector: 'app-program-achievement-test',
  templateUrl: './program-achievement-test.component.html',
  styleUrls: ['./program-achievement-test.component.scss']
})
export class ProgramAchievementTestComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any = TABS.PROGRAM_LESSON;
  ACHIEVEMENT_TEST: any = ACHIEVEMENT_TEST

  PROGRAM_KEY: any;
  LEVEL_KEY: any;
  ITEM: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: CurriculumStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(async (param) => {
      const { id, programKey } = param;
      this.LEVEL_KEY = id;
      this.PROGRAM_KEY = programKey;
      this.tabs = TABS.PROGRAM_LESSON.map(m => ({ path: `/programs/${programKey}/${this.LEVEL_KEY}/${m.route}`, label: m.label }))
      await this.store.fetchProgram(this.PROGRAM_KEY)
      this.ITEM = await this.store.fetchProgramLevelData(this.PROGRAM_KEY, this.LEVEL_KEY);
      // this.store.fetchProgramLessons(this.PROGRAM_KEY, this.LEVEL_KEY);
    })
  }

  addItem(item: any) {
    // let dialogRef = this.dialog.open(AddProgramLevelLessonComponent, {
    //   data: {
    //     LESSON: item,
    //     PROGRAM_KEY: this.PROGRAM_KEY,
    //     LEVEL_KEY: this.LEVEL_KEY
    //   },
    //   panelClass: 'item-list-panel',
    //   width: '',
    //   height: '100vh',
    //   disableClose: true,
    //   role: 'dialog',
    // });
    // dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    // dialogRef.afterClosed().subscribe(result => { });
  }


  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        // this.store.delete(COLLECTION_NAME.LEVEL, item, (success) => {
        //   if (success) {
        //     this.snackBar.open("Level has been deleted successful.", "Done", { duration: 2500 });
        //   }
        // })
      }
    });
  }
}
